function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
  fill: "#ffda44"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.333h512v48.868H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
  fill: "#d80027"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 378.542h512v48.128H0z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M276.992 255.996L106.329 426.659H0V85.333h106.329z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M256 255.996L85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M102.465 202.57l13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M138.94 259.335l-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 001.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z",
  fill: "#ffda44"
});

const SvgZimbabwe = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZimbabwe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/zimbabwe.758bffab.svg";
export { ForwardRef as ReactComponent };